import { combineReducers } from "redux";
import ProductsReducer from "./Products";
import RenewReducer from "./Renew";
import UserProfileReducer from "./UserProfile";

// reducers
const appReducer = combineReducers({
  products: ProductsReducer,
  renew: RenewReducer,
  up: UserProfileReducer
});

export default appReducer;
